// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import browserHistory from 'react-router/lib/browserHistory';
import moment from 'moment';
// Components
import ShareButton from '../../ShareButton/ShareButton';
import OMBasePropertyCell
  from '../OMPropertyCells/OMBasePropertyCell/OMBasePropertyCell';
// Helpers
import makeSharingUrl from '../../../utils/makeSharingUrl';
import { formatPropertyTitle } from '../../../utils/formatSEOData';
import getButtonsConfig
  from '../../../pages/ManagePropertiesPage/controlButtonsConfig';
import checkIsForeignAddress from '../../../helpers/checkIsForeignAddress';
import appendLocale from '../../../helpers/appendLocale';
import { addEnding } from '../../../utils/getIconStatus';
import { trackModalOpen } from '../../../utils/analytics/analyticsManager';
import parkingConverter from '../../../utils/parkingConverter';
import { ENTITY_TYPES, ROUTES } from '../../../constants';
// Styles
import * as styles from './OMRegularManageCellMobile.scss';
import * as shareBtnStyles from '../../ShareButton/ShareButton.scss';
import formatTimeFromDate from '../../../helpers/formatTimeFromDate';


class OMRegularManageCellMobile extends Component {
  formatShareData = () => {
    const { property: { thumbnail, slug }, locale, translate } = this.props;
    const sharingUrl = makeSharingUrl(`/home-details/${slug}`, locale);
    const propertyType = this.props.translate('propertyTypes', this.props.property.property_type)();

    const sharingTitle = formatPropertyTitle(
      this.props.property,
      propertyType,
      translate('propertyDetails'),
      locale
    );
    return {
      sharingUrl,
      sharingTitle,
      thumbnail
    };
  };

  handleEdit = (event) => {
    event.stopPropagation();
    this.props.editProperty(this.props.id);
    setTimeout(() => {
      browserHistory.push(appendLocale(this.props.locale, `/property/edit?id=${this.props.id}`));
    });
  };

  handleSecondJump = () => {
    this.props.openJumpToTopModal();
  };

  handleUpgradePackage = () => {
    this.props.openUpgradePackageModal(this.props.id);
  };

  toggleActivity = () => (!this.props.suspended) && this.props.updatePropertyActivity({
    properties: [this.props.property],
    active: !this.props.isActive
  });

  openDetailsPopup = (event) => {
    this.props.openDetailsPopup(this.generatePreloadData());
    trackModalOpen(`property/${this.props.id}`);
  };

  generatePreloadData = () => ({
    propertyId: this.props.id,
    slug: this.props.slug,
    address: this.props.addressData,
    price: this.props.price,
    additionalInfo: {
      area: this.props.area,
      floor: this.props.floor === 0 ? this.props.groundFloorTitle.toString() : this.props.floor,
      parkingSpots: parkingConverter(this.props.parkingSpots),
      rooms: this.props.rooms
    },
    propertyType: this.props.propertyType,
    optionType: this.props.optionType
  });

  clickHandlers = {
    handleEdit: this.handleEdit,
    handleSecondJump: this.handleSecondJump,
    openDetailsPopup: this.openDetailsPopup,
    toggleActivity: this.toggleActivity,
    upgradePackage: this.handleUpgradePackage
  };

  toggleAutoJumpActivity = () => {
    const { id, is_active: isActive, is_suspended: isSuspended,
      is_autojump_enabled: autoJumpEnabled } = this.props.property;

    if (isActive && !isSuspended && !this.props.disabledPromotionAction) {
      this.props.updateAutoJumpToTopActivity({
        ids: [id],
        enable: !autoJumpEnabled
      });
    }
  };

  toggleHighlight = () => {
    const { id, is_promoted: isPromoted, is_active: isActive,
      is_suspended: isSuspended } = this.props.property;

    if (isActive && !isSuspended && !this.props.disabledPromotionAction) {
      this.props.updatePropertyHighlighting({
        ids: [id],
        promote: !isPromoted
      });
    }
  };
  toggleTopPromotion = () => {
    const { id, is_top_promoted, is_active, is_suspended, thumbnail } = this.props.property;

    if (thumbnail && is_active && !is_suspended && !this.props.disabledPromotionAction) {
      this.props.updateTopPromotionActivity({
        ids: [id],
        promote: !is_top_promoted
      });
    } else {
      this.props.openMessageModal({ message: (
        <div>{this.props.translate('managePage', 'requiredPromotionTopDescription')}</div>
      ) });
    }
  };

  checkIsProjects = (props = this.props) => (get(props, 'routeData.location') === ROUTES.PROJECT_DETAILS) ||
    (get(props, 'preloadData.entityType') === ENTITY_TYPES.PROJECT);

  renderControlButton = ({ props: { className, ...restProps }, icon, title }) => (
    <button
      className={cx(styles.controlButton, className)}
      {...restProps}
    >
      <i className={`icon icon-${icon}`} >
        <i className="path1" />
        <i className="path2" />
        <i className="path3" />
        <i className="path4" />
        <i className="path5" />
        <i className="path6" />
        <i className="path7" />
      </i>
      {!this.props.isMobile && (<br />)}
      <span>{title}</span>
    </button>
  );

  renderAutoJumpDataTitle = () => {
    const { manual_jump_date: manualJumpDate } = this.props.property;

    if (!!manualJumpDate) {
      return `
        ${this.props.jumpToTopTooltipText}
        ${this.props.translate('managePage', 'manualJumpDate')}
        ${formatTimeFromDate(manualJumpDate)}
      `;
    }

    return this.props.jumpToTopTooltipText;
  }

  renderControlButtons = () => {
    if (!this.props.editable) {
      return null;
    }

    const { isActive, jumpToTopTooltipText, canSecondJump } = this.props;

    const buttonsConfig = getButtonsConfig(this.props, this.clickHandlers);
    const isForeignProperty = checkIsForeignAddress(this.props.addressData);

    const mobileControls = (
      <div>
        <div className={styles.btnWr}>
          {!isForeignProperty && this.renderControlButton(buttonsConfig.upgradePackage)}
          {this.renderControlButton(buttonsConfig.activity)}
        </div>
        {!isForeignProperty &&
          <div className={styles.moveToTopButtonWrap}>
            <div className={styles.moveToTopButton}>
              {this.renderControlButton(buttonsConfig.jumpToTop)}
              {(canSecondJump) && (this.renderControlButton(buttonsConfig.secondJumpToTop))}
            </div>
            {isActive && (<div className={styles.moveToTopTooltip}>{this.renderAutoJumpDataTitle()} </div>)}
          </div>
        }
      </div>
    );

    return (
      <div className={styles.propertyDesc} ref={this.createControlButtonsRef}>
        {mobileControls}
      </div>
    );
  };

  renderPropertyViews = () => {
    const { propertyViews, propertyViewsText, propertyNumber, propertyFavorites } = this.props;
    if (!this.props.editable) {
      return null;
    }

    const isForeign = checkIsForeignAddress(this.props.addressData);
    const phoneClicksCount = propertyNumber || get(this.props, 'property.phone_clicks_count', 0);
    const favouritesCount = propertyFavorites || get(this.props, 'property.favourites_count', 0);

    const viewsIcon = (
      <i className="icon icon-eye" >
        <span className="path1" />
        <span className="path2" />
      </i>
    );
    const viewsCount = propertyViews || 0;

    const buttonContent = [
      { id: 1, value: viewsIcon },
      { id: 2, value: propertyViewsText },
      { id: 3, value: viewsCount }
    ];

    return (
      <div className={styles.propertyInformationWrapper}>
        <div className={styles.propertyViews} onClick={this.showViewsChart}>
          {buttonContent.map(item => <span key={item.id}>{item.value}</span>)}
        </div>
        {!isForeign && (
          <div className={styles.phoneClicksCount}>
            <i className="icon icon-phone" />&nbsp;&nbsp;
            <span>{phoneClicksCount}</span>
          </div>
        )}
        <div className={styles.favouritesCount}>
          <i className="icon icon-favorite" />&nbsp;&nbsp;
          <span>{favouritesCount}</span>
        </div>
      </div>
    );
  };

  renderPromotions = () => {
    const isForeign = checkIsForeignAddress(this.props.addressData);

    if (!this.props.editable || isForeign) {
      return null;
    }

    const { autoJumpEnabled, promoted, isTopPromotedProperty, isCanManagePromotions } = this.props;
    const autoJumpStatus = autoJumpEnabled ? 'Active' : 'Disabled';
    const promotionStatus = promoted ? 'Active' : 'Disabled';
    const topPromotionStatus = isTopPromotedProperty ? 'Active' : 'Disabled';

    const topPromotion = get(this.props, 'userProperties.data.meta.user_properties.top_promotion', null);
    const highlight = get(this.props, 'userProperties.data.meta.user_properties.promotion', null);
    const autoJump = get(this.props, 'userProperties.data.meta.user_properties.jump_promotion', null);

    const promotionUntilTopPromotion = (topPromotion.until && moment(topPromotion.until));
    const promotionUntilTopPromotionFormatted = ((promotionUntilTopPromotion && promotionUntilTopPromotion.utc().format('DD/MM/YYYY')) || '-');

    const promotionUntilHighlight = (highlight.until && moment(highlight.until));
    const promotionUntilHighlightFormatted = ((promotionUntilHighlight && promotionUntilHighlight.utc().format('DD/MM/YYYY')) || '-');

    const promotionUntilAutoJump = (autoJump.until && moment(autoJump.until));
    const promotionUntilAutoJumpFormatted = ((promotionUntilAutoJump && promotionUntilAutoJump.utc().format('DD/MM/YYYY')) || '-');


    return (
      <div className={styles.promotionsBlock}>
        <span className={styles.promotionsTitle}>{this.props.translate('managePage', 'promotionsTitle')}:</span>
        <div>
          <i
            onClick={isCanManagePromotions && this.toggleTopPromotion}
            data-title={this.props.translate(`topPromotion${topPromotionStatus}RegularUserTitle`).replace('___', `${String.fromCharCode(8207)}TOP`)}
            className={cx(
              `icon icon-top-promotion${addEnding(topPromotionStatus.toLocaleLowerCase())}`,
            )}
          >
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>
          {topPromotionStatus === 'Active' ? promotionUntilTopPromotionFormatted : ''}
        </div>
        <div>
          <i
            onClick={isCanManagePromotions && this.toggleHighlight}
            data-title={this.props.translate(`highlight${promotionStatus}RegularUserTitle`)}
            className={cx(
              `icon icon-promoted${addEnding(promotionStatus.toLocaleLowerCase())}`,
            )}
          >
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>
          {promotionStatus === 'Active' ? promotionUntilHighlightFormatted : ''}
        </div>
        {/* <div>
          <i
            onClick={isCanManagePromotions && this.toggleAutoJumpActivity}
            data-title={this.props.translate(`autoJump${autoJumpStatus}RegularUserTitle`)}
            className={`icon icon-auto-jump${addEnding(autoJumpStatus.toLocaleLowerCase())}`}
          >
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>
          {autoJumpStatus === 'Active' ? promotionUntilAutoJumpFormatted : ''}
        </div> */}
      </div>
    );
  };

  renderInactiveOverlay = () => {
    if (this.props.isActive || !this.props.editable) {
      return null;
    }

    return (
      <div className={styles.inactiveOverlay} />
    );
  };

  render() {
    const { property: { id, is_promoted: isPromoted }, locale, translate, isNative } = this.props;
    const isProject = this.checkIsProjects() ? 'project' : 'home';
    return (
      <div className={cx(styles.wrapper, { [styles.colorHighlight]: isPromoted })}>
        <OMBasePropertyCell
          imageModifier={this.props.imageModifier}
          classNameProperty="propertiesListMobile"
          onHandlerEdit={this.handleEdit}
          onOpenDetails={this.clickHandlers.openDetailsPopup}
          active={this.props.isActive}
          showManagePropertiesPack
          {...this.props}
          propertyType={(this.props.editable) ? this.props.optionAndPropertyTypes : this.props.propertyType}
        />
        {this.renderPromotions()}
        {this.renderPropertyViews()}
        <ShareButton
          id={id}
          locale={locale}
          translate={translate}
          isNative={isNative}
          formatShareData={this.formatShareData()}
          isProject={this.checkIsProjects()}
          shareLinkClassName={shareBtnStyles.shareBtn}
          shareBlockClassName="sharePropertiesMobileBlock"
        />
        {this.renderControlButtons()}
        {this.renderInactiveOverlay()}
      </div>
    );
  }
}

OMRegularManageCellMobile.propTypes = {
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  propertyType: PropTypes.string,
  optionAndPropertyTypes: PropTypes.string,
  photo: PropTypes.string,
  price: PropTypes.number,
  address: PropTypes.string,
  rooms: PropTypes.number,
  parkingSpots: PropTypes.object,
  city: PropTypes.string,
  area: PropTypes.number,
  floor: PropTypes.number,
  isFavorite: PropTypes.bool,
  isNewProperty: PropTypes.bool,
  hasVRLink: PropTypes.bool,
  propertyNote: PropTypes.string,
  parkingIconTitle: PropTypes.func,
  roomsIconTitle: PropTypes.func,
  editProperty: PropTypes.func,
  propertyViewsText: PropTypes.func,
  property: PropTypes.object,
  floorIconTitle: PropTypes.func,
  squareIconTitle: PropTypes.func,
  groundFloorTitle: PropTypes.func,
  openUpgradePackageModal: PropTypes.func,
  addPropertyNote: PropTypes.func,
  toggleFavorite: PropTypes.func,
  searchOption: PropTypes.string,
  propertyViews: PropTypes.number,
  createdAt: PropTypes.string,
  loadSinglePropertyAnalytics: PropTypes.func,
  openChartOfViews: PropTypes.func,
  editable: PropTypes.bool,
  translate: PropTypes.func,
  openJumpToTopModal: PropTypes.func,
  optionType: PropTypes.string,
  isActive: PropTypes.bool,
  openDetailsPopup: PropTypes.func,
  copyLinkText: PropTypes.func,
  canSecondJump: PropTypes.bool,
  openModalShare: PropTypes.func,
  suspended: PropTypes.bool,
  jumpToTopTooltipText: PropTypes.func,
  updatePropertyActivity: PropTypes.func,
  addressData: PropTypes.object,
  promoted: PropTypes.bool,
  autoJumpEnabled: PropTypes.bool,
  isTopPromotedProperty: PropTypes.bool,
  userProperties: PropTypes.object,
  updateAutoJumpToTopActivity: PropTypes.func,
  updatePropertyHighlighting: PropTypes.func,
  updateTopPromotionActivity: PropTypes.func,
  disabledPromotionAction: PropTypes.bool,
  isCanManagePromotions: PropTypes.bool,
  openMessageModal: PropTypes.func,
  propertyNumber: PropTypes.number,
  propertyFavorites: PropTypes.number,
  isNative: PropTypes.bool,
  slug: PropTypes.string,
  imageModifier: PropTypes.string
};

export default OMRegularManageCellMobile;
